module.exports = __webpack_public_path__ + "img/SKMJ_notake.db33217c.jpg";